import { register } from "async-ops";
import { callMvcApi } from "../../../call-web-api";
export const IS_CODER_WORKFLOW_ENABLED_FOR_CLIENT = "IS_CODER_WORKFLOW_ENABLED_FOR_CLIENT";

export const service = async () => {
  const options: object = {
    url: "/api/Client/isCoderWorkFlowEnabledForClient/",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(IS_CODER_WORKFLOW_ENABLED_FOR_CLIENT, service, mock);
